module.exports = __webpack_public_path__ + "static/media/designPatent_30-1018447.dddd1095.png";